import {
    IComponentController,
    IComponentOptions,
    IOnChangesObject,
    IPromise,
} from 'angular';

import { FontLoader } from '../../../../tn.fonts/fontloader.service/fontloader.service';
import { IFontStyleModel, VFCustomAxes } from '../../../classes';
import { getCssFontVariationSettings, getFontName } from '../../../functions';
import { SpecimenService } from '../../../providers';
import template from './specimen-raw.html';

export class RawSpecimenComponentBindings {
    font?: IFontStyleModel;
    variationSettings?: Record<VFCustomAxes, number>;
    // size in pixels
    size = 0;
    // whole number percentage to scale the font-size by.
    scale = 100;
    specimenText = '';
}

export class RawSpecimenComponent
    extends RawSpecimenComponentBindings
    implements IComponentController
{
    // #region locals
    _cssStyle = 'font-family: "Adobe Blank";';
    _loadingFont = true;
    // #endregion

    static $inject = ['specimenService', 'tn.fontloader.service'];
    constructor(
        protected specimenService: SpecimenService,
        protected fontLoader: FontLoader
    ) {
        super();
    }

    $onChanges(changes: IOnChangesObject): void {
        // console.log('RawSpecimenComponent.$onChanges', changes);
        if (changes.font && changes.font.currentValue) {
            this.loadFont();
        }
        if (changes.scale || changes.variationSettings || changes.size) {
            // console.log('SpecimenComponent.$onChanges', changes.scale.currentValue, this.scale);
            this.setCssStyle();
        }
    }

    loadFont(): IPromise<number | void> {
        // mark as loading so we can show a throbber if we need to.
        this._loadingFont = true;
        // hide until reloaded.
        this._cssStyle = 'font-family: "Adobe Blank";';

        return this.fontLoader
            .get(this.font)
            .then((font_file_id) => {
                if (this.font?.font_file_id != font_file_id) {
                    // if the font loader returns a font_file_id different from the current font, the loader was called with
                    // an undefined font or the font changed while waiting to load. In these case ignore
                    // the stale and noop font load request.
                    return;
                }
                this.setCssStyle();
                this._loadingFont = false;
            })
            .catch((error) => {
                console.log('RawSpecimenComponent._loadFont, Error', error);
                // TODO: how should we handle this error state.
                throw error;
            });
    }

    setCssStyle(): void {
        const cssName = this.font ? getFontName(this.font) : '';
        const _cssFontFamily = `"${cssName}", "Adobe Blank"`;
        // if the style has an axis property, then we were passed an instance and not
        // the variable, so use the values from the instance instead of dynamically supplied..
        const variationSettings =
            this.font?.axis?.axes || this.variationSettings;
        const variation = getCssFontVariationSettings(variationSettings);
        this._cssStyle = `font-family: ${_cssFontFamily}; font-size: ${this.size}px; font-variation-settings: ${variation};`;
        this._loadingFont = false;
    }
}

export const RawSpecimenComponentOptions: IComponentOptions = {
    controller: RawSpecimenComponent,
    bindings: {
        // font family to use
        font: '<',
        // variation settings object
        variationSettings: '<?',
        // size in pixels...
        size: '<?',
        // text to display
        specimenText: '<?',
    },
    template: template,
};
